// extracted by mini-css-extract-plugin
export default {"itemButtons":"ItemAmountButtons_itemButtons__qtg2r","iconBag":"ItemAmountButtons_iconBag__tGQ6Y","itemAmоunt":"ItemAmountButtons_itemAmоunt__FwCxJ"};